import { Chip } from '@heroui/react';
import CloudsBackground from '../../pages/pricing/components/CloudsBackground';

type PageCloudHeroProps = {
  badge: string;
  badgeIcon: string;
  title: string;
  lead: string;
  supporting: string;
};

export default function PageCloudHero({
  badge,
  badgeIcon,
  title,
  lead,
  supporting,
}: PageCloudHeroProps) {
  return (
    <section className="relative min-h-[32rem] overflow-hidden pb-28 pt-36 md:min-h-[40rem] md:pb-40 md:pt-44">
      <CloudsBackground />

      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_18%_20%,rgba(163,230,53,0.08),transparent_28%),radial-gradient(circle_at_80%_16%,rgba(64,196,255,0.12),transparent_28%)]" />

      <div className="pointer-events-none absolute inset-0">
        <div className="absolute left-[8%] top-[14%] h-64 w-64 rounded-full bg-brand-green/5 blur-3xl" />
        <div className="absolute right-[-8%] top-[6%] h-80 w-80 rounded-full bg-brand-ocean/7 blur-3xl" />
        <div className="absolute left-[34%] top-[8%] h-48 w-48 rounded-full bg-white/[0.025] blur-3xl" />
      </div>

      <div className="relative z-10 mx-auto max-w-5xl px-6 text-center">
        <div>
          <Chip
            variant="flat"
            className="mb-5 border border-white/10 bg-[#464646] px-4 py-2 text-sm font-semibold text-[#A3E635] shadow-[inset_0_1px_0_rgba(255,255,255,0.04)] backdrop-blur-md"
            startContent={
              <span className="mr-2 inline-flex items-center">
                <i className={`${badgeIcon} text-base`} />
              </span>
            }
          >
            {badge}
          </Chip>

          <h1 className="text-5xl font-caprasimo tracking-tight text-[#101010] drop-shadow-[0_1px_0_rgba(255,255,255,0.08)] md:text-6xl">
            {title}
          </h1>
          <p className="mx-auto mt-6 max-w-3xl text-lg leading-relaxed text-[#0D0D0D] md:text-xl">
            {lead}
          </p>
          <p className="mx-auto mt-4 max-w-2xl text-sm leading-7 text-[#546274] md:text-base">
            {supporting}
          </p>
        </div>
      </div>
    </section>
  );
}
